import { createAction } from 'redux-actions'

export default function createLoadingAction(name, indicator) {
  return createAction(name, payload => payload, () => ({ indicator }))
}
